export default "__VITE_ASSET__BBr_4ldd__"